import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ChatWrapper from '@/components/elements/ChatWrapper.vue';
import { ChatItem } from '@/types/chat';
import { computed, toRef } from 'vue';
import useAudioTranscription from '@/utilities/composables/useAudioTranscription';
import { convertToHoursMinutes } from '@/utilities/timeDifference';
import { NoteTranscriptSource } from '@superthread-com/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'NoteTranscriptionChat',
  props: {
  noteId: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { transcripts } = useAudioTranscription(toRef(props, 'noteId'));

const chatItems = computed((): ChatItem[] => {
  return transcripts.value.map((t: any) => ({
    id: t.id,
    content: !t.ongoing ? t.content : `${t.content || ''} ${t.interim_content}`,
    timestamp: convertToHoursMinutes(new Date(t.time_created + 1000)),
    alignment: t.source === NoteTranscriptSource.Author ? 'right' : 'left',
    processing: t.ongoing,
  }));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ChatWrapper, { items: chatItems.value }, null, 8, ["items"]))
}
}

})